import styled, { css } from 'styled-components'
import { Transition } from 'utils/constants'

export const LinkStyled = styled.a`
  color: var(--t-link-color);
  cursor: pointer;
  transition: color ${Transition.ms200};
  &:hover {
    color: color-mix(in srgb, var(--p-blue-400) 80%, black 20%);
  }

  ${({ $isSubtask }) =>
    $isSubtask === 'subtasks' &&
    css`
      color: var(--t-link-subtask-text);

      &:hover {
        color: color-mix(in srgb, var(--p-blue-350) 80%, black 20%);
      }
    `}
`
